export default "__VITE_ASSET__D8n8CT3v__"